module.exports = __webpack_public_path__ + "static/media/Roboto-Black.232725fa.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Roboto-Black.ttf
// module id = 539
// module chunks = 0